<template>
    <div class="registry-wrapper">
        <empty-table-message
            v-if="data.table && !data.table.length"
            msg="msg-empty-ven-cliente-checks"
        />
        <b-table
            v-else
            class="data-table"
            :data="data.table"
            backend-sorting
            @sort="loadSort"
        >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :width="f.width"
                    :centered="f.centered"
                    :label="$t(f.label)"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <div 
                        v-if="f.key == 'checkindatahora' || f.key == 'checkoutdatahora'"
                        :class="{'has-check-photo': f.key == 'checkindatahora' ? props.row.documentos && props.row.documentos.findIndex(e => e.datahora == props.row.checkindatahora) > -1 : props.row.documentos && props.row.documentos.findIndex(e => e.datahora == props.row.checkoutdatahora) > -1}"
                    >
                        {{ props.row[f.key] ? $moment(props.row[f.key]).format("L LT") : '' }}
                    </div>
                    <div v-else-if="f.key == 'verificouqrcode'">
                        {{ props.row[f.key] == "S" ? $t('sim') : $t('nao') }}
                    </div>
                    <div v-else-if="f.key == 'usuario'">
                        {{ props.row.usuario.nome }}
                    </div>
                    <div v-else-if="f.key == 'fotos'">
                        <a 
                            :class="{ 'text-darker-grey': !props.row.documentos || !props.row.documentos.length }"
                            @click="openCheckPhoto(props.row)"
                            v-tippy 
                            :title="getFotoButtonTooltip({ length: props.row.documentos.length })"
                        >
                            <i class="fas fa-camera icon"></i>
                        </a>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
        </b-table>
        <b-pagination
            order="is-centered"
            :total="data.total"
            :current.sync="data.page"
            :per-page="data.perPage"
            @change="loadPage"
        />

        <!-- MODAL DAS FOTOS -->
        <b-modal :active="isCheckModalOpen" @close="closeCheckPhoto">
            <div class="modal-card" v-if="documentosPDA">
                <header class="modal-card-head">
                    <p class="title is-marginless is-paddingless">{{ $t('fotos-check-in-out') }}</p>
                </header>
                <section class="modal-card-body">
                    <div class="columns">
                        <div class="column is-half pic-wrapper" v-for="(p, i) in documentosPDA" :key="i">
                            <span>{{ $t(p.label) }}: {{ p.datahora | moment("L LT") }}</span>
                            <a :href="p.url_documento" target="new">
                                <img :src="p.url_documento" :alt="p.url_documento">
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
    </div>
</template>

<script>

export default {
    props: {
        data: {
            type: Object,
            default: () => {
                return {
                    table: []
                }
            }
        },
    },
    data() {
        return {
            fields: [
                { key: "checkindatahora",   label: 'data-check-in',     sortable: true,  width: 160,  centered: false },
                { key: "checkoutdatahora",  label: 'data-check-out',    sortable: true,  width: 160,  centered: false },
                { key: "usuario",           label: 'vendedor',          sortable: true,  width: null, centered: false },
                { key: "verificouqrcode",   label: 'verificou-qr-code', sortable: true,  width: 160,  centered: true  },
                { key: "fotos",             label: 'fotos',             sortable: false, width: null, centered: true  }
            ],
            column: '',
            order: '',
            isCheckModalOpen: false,
            documentosPDA: []
        }
    },
    methods: {
        showMessage(type, message) {
            let data = {
                type: type,
                message: message
            };

            this.$emit("alert", data);
        },
        loadPage(pageNumber) {
            let query = {
                page: pageNumber,
                limit: this.data.perPage,
                column: this.column,
                order: this.order
            };

            this.$emit("load-page", query);
        },
        loadSort(field, order) {
            this.column = field;
            this.order = order;

            this.loadPage(this.data.page);
        },
        openCheckPhoto(check) {
            if (check.documentos && check.documentos.length) {
                this.documentosPDA = check.documentos;

                this.documentosPDA.forEach(e => {
                    if (e.datahora == check.checkindatahora) {
                        e.label = 'check-in';
                    } else if (e.datahora == check.checkoutdatahora) {
                        e.label = 'check-out';
                    } else {
                        e.label = 'data';
                    }
                });

                this.isCheckModalOpen = true;
            }
        },
        closeCheckPhoto() {
            this.isCheckModalOpen = false;
            this.documentosPDA = null;
        },
        openPicture(url) {
            window.open(url, '_blank');
        },
        getFotoButtonTooltip({ length }) {
            if (!length) {
                return this.$t('sem-fotos');
            }
            return this.$t('fotos-check-in-out');
        },
    }
}
</script>

<style lang="scss" scoped>
.pic-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    font-weight: 600;

    span {
        width: 100%;
        text-align: center;
    }

    img {
        cursor: pointer;
        max-height: 60vh;
    }
}

section.modal-card-body {
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;

    .columns {
        justify-content: center;
    }
}

.text-darker-grey {
    color: $darker-gray-color !important;
}
</style>